<template>

  <div class="wrapper">
<!--    <el-header>
      <v-header></v-header>
    </el-header>-->
    <el-container>
      <div class="search-wrap"
           v-loading="loading"
           element-loading-text="拼命加载中"
           element-loading-spinner="el-icon-loading">
        <el-form class="search-box" ref="form" :model="form" :rules="rules">
          <el-form-item prop="email">
            <el-input
              v-model="form.email"
              @keydown.enter.native="onSubmit"
              placeholder="Email"
            >
              <el-button
                @click="onSubmit"
                slot="append"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-form>

        <template v-for="(item, key) in items">
          <div class="main" :key="key">
            <div class="shop-logo">
              <div class="right-logo">
                <img class="logo" src="@/assets/image/store.png"/>
              </div>
              <h3>{{ key }}</h3>
            </div>
            <div class="userinfo">
              <div style="margin-bottom: 5px">
                <span style="font-size: 16px">{{ item[0].customer.first_name }} {{ item[0].customer.last_name }}</span>
              </div>
              <div>
                <!--订单数总计-->
                <span class="left-text">{{ $t("search.total_order_count") }}:</span>
                <span class="right-text">{{ item.length }} </span>
              </div>
              <div>
                <!--已花费金额总计-->
<!--                <span class="left-text">{{ $t("search.total_amount_spent") }}:</span>
                <span class="right-text"
                >US${{ item[0].customer.total_spent }}
                </span>-->
              </div>
            </div>
            <template v-for="order in item">
              <div :key="order.id">
                <el-collapse v-model="activeNames" @change="handleChange">
                  <i
                    class="el-icon-warning warn"
                    v-if="item[0].disputes == undefined ? false : true"></i>
                  <el-collapse-item
                    class="order-nub"
                    :title="order.name"
                    :name="order.id">
                    <div>
                      <!--创建于-->
                      <span class="left-text">{{ $t("search.created") }}:</span>
                      <span class="right-text">
                        {{ $moment(order.created_at).tz("America/New_York").format("MM/DD/YYYY HH:mm:ss") }}</span>
                      <span class="order-price">${{ order.total_price }}</span>
                    </div>
                    <div>
                      <span>{{ order.fulfillment_status || $t("search.not_found") }}</span>
                      <span class="fulfillment_status">
                        {{ order.financial_status }}
                      </span>
                    </div>
                    <div>
                      <!--订单-->
                      <span class="left-text">{{ $t("search.order") }}:</span>
                      <span class="right-text">{{ order.name }}</span>
                    </div>
                    <div class="shipping_information" v-if="order.shipping_address">
                      <div>
                      <!-- 送货信息 -->
                        <div class="left-text" style="font-weight: 600;color: #303133">{{ $t("search.shipping_information") }}</div>
                        <span class="left-text">{{ $t("search.shipping_address") }}:</span>
                        <span class="right-text">{{order.shipping_address.first_name}} {{ order.shipping_address.last_name}},{{ order.shipping_address.address1}},{{ order.shipping_address.city}},{{ order.shipping_address.province_code}},{{ order.shipping_address.zip}},{{ order.shipping_address.country}}</span>
                      </div>
                      <div>
                        <!-- 电话号码 -->
                        <span class="left-text">{{ $t("search.phone") }}:</span>
                        <span >{{order.shipping_address.phone }}</span>
                      </div>
                    </div>

                    <div class="shipping_information" v-else>
                      <div>
                        <!-- 送货信息 -->
                        <div class="left-text" style="font-weight: 600;color: #303133">{{ $t("search.shipping_information") }}</div>
                        <span class="left-text">{{ $t("search.shipping_address") }}:</span>
                        <span class="right-text">{{order.billing_address.first_name}} {{ order.billing_address.last_name}},{{ order.billing_address.address1}},{{ order.billing_address.city}},{{ order.billing_address.province_code}},{{ order.billing_address.zip}},{{ order.billing_address.country}}</span>
                      </div>
                      <div>
                        <!-- 电话号码 -->
                        <span class="left-text">{{ $t("search.phone") }}:</span>
                        <span >{{order.billing_address.phone }}</span>
                      </div>
                    </div>


                    <div v-if="order.fulfillments == undefined ? false : true">
                      <template v-for="fulfillment in order.fulfillments">
                        <!--跟踪号码-->
                        <div :key="fulfillment.id">
                          <span class="left-text" style="font-weight: 600;color: #303133" >{{ $t("search.tracking_numbers") }}:</span>
                          <a :href="fulfillment.tracking_url"
                             class="right-text"
                             target="_blank"
                          >
                            {{ fulfillment.tracking_number }}
                          </a>
                          <i class="el-icon-copy-document"
                             style="color:cornflowerblue"
                             v-clipboard:copy="fulfillment.tracking_number"
                             v-clipboard:success="onCopy"
                             v-clipboard:error="onError"></i>
                        </div>
                      </template>
                    </div>
                    <div>
                      <a :href="order.order_status_url" target="_blank">
                      <!--跳转订单信息页面-->
                      {{ $t("search.view_order") }}
                     </a>
                     <!-- 后台查看订单    -->
                       <a class="shopify-admin"
                         :href="'https://' +key +'.myshopify.com/admin/orders/'+order.id" target="_blank">
                         {{ $t("search.view_in_background") }}
                      </a>
                    </div>

                    <template>
                      <div>
                        <!--商品详情-->
                        <el-collapse-item :title='$t("search.product_details")' :name="order.id + 1">
                          <template v-for="orders in order.line_items">
                            <div :key="orders.id">
                              <div v-if="orders.title != 'Tip'">

                                <div class="product-name">
                                  <div class="right-text order-name" style="color: #66b1ff">
                                    {{ orders.name }}
                                  </div>
                                  <span
                                    class="order-quantity"
                                    style="float:right;">
                                    ${{ orders.price }}x{{ orders.quantity }}
                                  </span>
                                  <!-- <span class="order-price"
                                    >${{ order.subtotal_price }}</span
                                  > -->
                                </div>
                                <div class="payment">
                                  <div>
                                    <!--支付明细-->
                                    <div class="subtotal">{{ $t("search.payment_breakdown") }}</div>
                                    <span class="projectname">{{ orders.quantity }}{{$t("search.items")}}</span>
                                    <span class="orderprice">${{ orders.price }}</span>
                                  </div>

                                </div>

                              </div>
                              <dir v-else>
                                <span>Tip</span>
                                <span class="tip">${{ orders.price }}</span>
                              </dir>
                            </div>
                          </template>
                        </el-collapse-item>
                        <template>
                          <div>
                            <div class="delivery-detail"
                                 v-for="delivery in order.shipping_lines"
                                 :key="delivery.id">
                              <!--送货-->
                              <div class="delivery">{{ $t("search.shipping") }}</div>
                              <div class="delivery-name">
                                {{ delivery.title }}
                              </div>
                              <span class="delivery-price"
                              >${{ delivery.price }}</span
                              >
                            </div>
                            <div>
                              <!--总计-->
                              <span>{{ $t("search.total") }}</span>
                              <span class="total_price">${{
                                  order.total_price
                                }}</span>
                            </div>
                            <div>
                              <!--付款方式-->
                              <span>{{ $t("search.payment_method") }}</span>
                              <span class="payment-method" v-for="(gateway,index) in order.payment_gateway_names" :key="index">{{ gateway }}</span><br>
                            </div>
                            <div class="use-pay">
                              <!--客户已支付-->
<!--                              <span>{{ $t("search.paid_by_customer") }}</span>
                              <span
                                class="total_spent">${{ order.customer.total_spent }}</span>-->
                            </div>
                          </div>
                        </template>
                        <el-popover
                          class="dispute"
                          placement="right"
                          width="385"
                          trigger="click"
                          v-if="order.disputes == undefined ? false : true">
                          <template v-for="dispute in order.disputes">
                            <div :key="dispute.dispute_id">
                              <div>
                                <!--事件编号-->
                                <span class="left-text">{{ $t("search.case_ID") }}: </span>
                                <span class="right-text">{{ dispute.dispute_id }} </span>
                                <i class="el-icon-copy-document"
                                   style="color:cornflowerblue"
                                   v-clipboard:copy="dispute.dispute_id"
                                   v-clipboard:success="onCopy"
                                   v-clipboard:error="onError"></i>
                              </div>
                              <div>
                                <!--收款账号-->
                                <span class="left-text">{{ $t("search.receiving_account") }}: </span>
                                <span class="right-text">{{ dispute.paypal_account }}</span>
                              </div>
                              <div>
                                <!--开立时间-->
                                <span class="left-text">{{ $t("search.opened_on") }}: </span>
                                <!--<span class="right-text">{{ dispute.create_time }}</span>-->
                                <span class="right-text">{{ $moment(dispute.create_time).format("MM/DD/YYYY HH:mm:ss") }}</span>
                              </div>
                              <div>
                                <!--争议理由-->
                                <span class="left-text">{{ $t("search.reason") }}: </span>
                                <span class="right-text">{{ firstToUpper(dispute.reason) }}</span>
                              </div>
                              <div>
                                <!--事件状态-->
                                <span class="left-text">{{ $t("search.status") }}: </span>
                                <span class="right-text">{{ firstToUpper(dispute.dispute_state) }}</span>
                              </div>
                              <div>
                                <!--争议金额-->
                                <span class="left-text">{{ $t("search.disputed_amount") }}: </span>
                                <span class="right-text">{{ dispute.dispute_amount.currency_code }} {{ dispute.dispute_amount.value }}</span>
                              </div>
                            </div>

                          </template>

                          <el-button
                            class="dispute-but"
                            type="warning"
                            slot="reference"
                            size="small">
                            {{ $t("search.disputed_information") }}
                          </el-button>
                        </el-popover>
                      </div>
                    </template>
                  </el-collapse-item>
                </el-collapse>
                <div class="separate"></div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </el-container>
  </div>
</template>

<script>
// import vHeader from "./components/Header";

export default {
  name: "Search",
  // components: {
  //   vHeader
  // },
  data() {
    return {
      loading: false,

      size: "",
      activeNames: ["1"],
      items: {},
      form: {
        email: ""
        // email: "piliw@163.com"
        // email: "chickadeew@yahoo.com",
        // email: "dwezel81@hotmail.com",
        // email: "kathleen_jenema2001@hotmail.com",
        // email: "becca_rmrz@yahoo.com"
      },
      rules: {
        email: [
          {required: true, message: "请输入Email", trigger: "blur"},
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.http.fetchGet(this.api.search, this.form).then((res) => {
            this.loading = false
            var data = res.data;
            // console.log(data.code)
            if (data.code === 1000) {
              var shops = data.data;
              // console.log(shops);
              this.items = shops;

              // console.log(this.items);
              // this.setLogin(access_token);
              // this.$message.success('登陆成功');
              // this.$router.push('/');
            } else {
              this.$message.error(data.message);
            }

            this.loading = false
            // 请求成功处理
          }).catch((err) => {
            console.log(err);
            this.loading = false
          });
        } else {
          // this.$message.error('请输入账号和密码');
          console.log("error submit!!");
          return false;
        }
      });
    },

    //纠纷信息处理
    firstToUpper(str) {

      str=str.toLowerCase()
      var bs = str.charAt(0);
      var cs = bs.toUpperCase();
      var ds = cs + str.slice(1);

      return ds.replaceAll("_"," ")
    },
    handleChange(val) {
      console.log(val);
    },

    onCopy: function (e) {
      this.$message.success("已复制 " + e.text)
    },
    onError: function (e) {
      console.log(e);
      this.$message.error("抱歉，复制失败！")
    },

  },
  // computed: {
  //   computedTotalPrice: (item) => {
  //     const quantity = item.quantity;
  //     const price = item.price;
  //     console.log(quantity);
  //     console.log(price);
  //     if (
  //       typeof quantity === "number" &&
  //       !isNaN(quantity) &&
  //       typeof price === "number" &&
  //       !isNaN(price)
  //     )
  //       return Number(quantity) * Number(price);
  //     return 0;
  //   },
  // },
};
</script>

<style scoped lang="stylus">

@import "~@/assets/css/varibles.styl"

.order-nub>>>.el-collapse-item__header
  color #9a6e3a

.el-header
  line-height $hdHeight
  height $hdHeight !important
  position relative
  left 0
  right 0
  top 0
  /*padding-bottom: 30px;*/
  -webkit-transition: left .3s ease-in-out
  transition: left .3s ease-in-out
  background: #acaca9
  color #fff
  padding 0


.search-wrap
  width: 30%
  margin: 20px auto
  position: relative


.main
  margin-top: 10px
  border: 1px solid #c0c0c0
  padding: 8px
  border-radius: 10px


.tip, .order-price, .total_spent, .fulfillment_status
  float: right


.el-icon-warning
  color: red

.order-name
  width: 45%
  float: left


.order-quantity
  margin-left: 20%


.userinfo
  padding: 10px
  line-height: 28px


.product-name
  width: 100%
  display: inline-block
  border-top: 1px solid #c0c0c0
  padding-top: 10px


.delivery-detail
  border-top: 1px solid black
  border-bottom: 1px dashed #c0c0c0
  padding-bottom: 10px
  margin-bottom: 10px


.total_price, .orderprice, .shopify-admin
  float: right


.warn
  float: left
  line-height: 45px
  margin-right: 5px


.shop-logo
  height: 2rem
  border-bottom: 1px solid #c0c0c0


.delivery-name
  width: 50%
  display: inline-block


.payment-method
  float: right


.delivery-price
  float: right


.use-pay
  border-bottom: 1px solid #99a9bf
  margin-bottom: 10px


.right-logo
  float: right
  width: 30px
  height: 30px
  text-align: center
  line-height: 42px

.el-icon-document-copy
    font-size:20px
    margin-left: 10px;

 .el-icon-document-copy:hover
    color:blue
.logo
  width: 80%


.demo-table-expand
  font-size: 0


.demo-table-expand label
  width: 90px
  color: #99a9bf

.shipping_information
    border-top: 1px solid #99a9bf
.demo-table-expand .el-form-item
  margin-right: 0
  margin-bottom: 0
  width: 50%


.left-text
  font-size: 16px
  font-weight: 400
  color: black


.right-text
  font-size: 15px
  margin-left: 5px


.dispute-but
  margin-top: 10px

.separate
  background-color #e1e4e8
  height 8px
  border-radius 3px
  margin-bottom 15px

</style>
